"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshAccountStorage = exports.logoutAccountStorage = exports.beginStatusStorage = exports.completeStatusStorage = exports.switchActiveStorage = exports.removeAccountStorage = exports.addAccountStorage = exports.getAccountManagerStorage = void 0;

var _arcgisRestAuth = require("@esri/arcgis-rest-auth");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var getAccountManagerStorage = function getAccountManagerStorage(manager) {
  var _ref = getLocalSerialized(manager) || {},
      accounts = _ref.accounts,
      active = _ref.active,
      status = _ref.status,
      order = _ref.order;

  var dAccounts = deserializeUserAuthObjects(accounts);
  var authObject = {
    accounts: dAccounts,
    active: active,
    status: status,
    order: order
  };
  return authObject;
};

exports.getAccountManagerStorage = getAccountManagerStorage;

var addAccountStorage = function addAccountStorage(manager, account) {
  var previous = getLocalSerialized(manager);

  var _ref2 = previous || {},
      accounts = _ref2.accounts,
      active = _ref2.active,
      setActive = _ref2.status.setActive;

  var updateActive = setActive || !active ? account.key : active;
  var order = previous.order ? previous.order.find(function (id) {
    return id === account.key;
  }) ? _toConsumableArray(previous.order) : [account.key].concat(_toConsumableArray(previous.order)) : [account.key];
  setLocal({
    state: _objectSpread({}, previous, {
      accounts: _objectSpread({}, accounts, _defineProperty({}, account.key, account)),
      active: updateActive,
      order: order
    }),
    manager: manager
  });
};

exports.addAccountStorage = addAccountStorage;

var removeAccountStorage = function removeAccountStorage(manager, _ref3) {
  var key = _ref3.key;
  var previous = getLocalSerialized(manager);
  var order = previous.order.filter(function (item) {
    return item !== key;
  });
  delete previous.accounts[key];
  var active = previous.active === key ? order.length > 0 ? order[0] : undefined : previous.active;
  setLocal({
    state: _objectSpread({}, previous, {
      active: active,
      order: order
    }),
    manager: manager
  });
};

exports.removeAccountStorage = removeAccountStorage;

var switchActiveStorage = function switchActiveStorage(manager, _ref4) {
  var key = _ref4.key;
  var previous = getLocalSerialized(manager);
  var orders = previous.order ? previous.order : [];
  var order = [key].concat(_toConsumableArray(orders.filter(function (item) {
    return item !== key;
  })));
  setLocal({
    state: _objectSpread({}, previous, {
      active: key,
      order: order
    }),
    manager: manager
  });
};

exports.switchActiveStorage = switchActiveStorage;

var completeStatusStorage = function completeStatusStorage(manager) {
  var previous = getLocalSerialized(manager);

  var _ref5 = previous || {},
      status = _ref5.status;

  setLocal({
    state: _objectSpread({}, previous, {
      status: _objectSpread({}, status, {
        loading: false
      })
    }),
    manager: manager
  });
};

exports.completeStatusStorage = completeStatusStorage;

var beginStatusStorage = function beginStatusStorage(manager, _ref6, originRoute, setActive) {
  var clientId = _ref6.clientId,
      redirectUri = _ref6.redirectUri,
      portalUrl = _ref6.portalUrl,
      popup = _ref6.popup;
  var previous = getLocalSerialized(manager);
  setLocal({
    state: _objectSpread({}, previous, {
      status: {
        loading: true,
        authProps: {
          clientId: clientId,
          redirectUri: redirectUri,
          portalUrl: portalUrl,
          popup: popup
        },
        originRoute: originRoute,
        setActive: setActive
      }
    }),
    manager: manager
  });
};

exports.beginStatusStorage = beginStatusStorage;

var logoutAccountStorage = function logoutAccountStorage(manager, _ref7) {
  var key = _ref7.key;
  var previous = getLocalSerialized(manager);

  var _ref8 = previous || {},
      accounts = _ref8.accounts;

  var user = _objectSpread({}, accounts[key], {
    token: null,
    session: null
  });

  setLocal({
    state: _objectSpread({}, previous, {
      accounts: _objectSpread({}, accounts, _defineProperty({}, key, user))
    }),
    manager: manager
  });
};

exports.logoutAccountStorage = logoutAccountStorage;

var refreshAccountStorage = function refreshAccountStorage(manager, _ref9) {
  var key = _ref9.key,
      session = _ref9.session;
  var previous = getLocalSerialized(manager);

  var _ref10 = previous || {},
      accounts = _ref10.accounts;

  setLocal({
    state: _objectSpread({}, previous, {
      accounts: _objectSpread({}, accounts, _defineProperty({}, key, _objectSpread({}, accounts[key], {
        session: session
      })))
    }),
    manager: manager
  });
}; //** State Management */


exports.refreshAccountStorage = refreshAccountStorage;

var setLocal = function setLocal(_ref11) {
  var state = _ref11.state,
      manager = _ref11.manager;
  window.localStorage.setItem(manager, JSON.stringify(state));
};

var getLocalSerialized = function getLocalSerialized(manager) {
  var accountManager = JSON.parse(window.localStorage.getItem(manager));

  var _ref12 = accountManager || {},
      accounts = _ref12.accounts,
      active = _ref12.active,
      status = _ref12.status,
      order = _ref12.order;

  var authObject = {
    accounts: accounts,
    active: active,
    status: status,
    order: order
  };
  return authObject;
};

var deserializeUserAuthObjects = function deserializeUserAuthObjects(accounts) {
  var dUsers = {};

  if (accounts) {
    var _arr = Object.entries(accounts);

    for (var _i = 0; _i < _arr.length; _i++) {
      var _arr$_i = _slicedToArray(_arr[_i], 1),
          key = _arr$_i[0];

      var deserializedSession = accounts[key].session ? _arcgisRestAuth.UserSession.deserialize(accounts[key].session) : undefined;
      var deserializedPortal = accounts[key].portal ? JSON.parse(accounts[key].portal) : undefined;
      dUsers[key] = _objectSpread({}, accounts[key], {
        portal: deserializedPortal,
        session: deserializedSession
      });
    }
  }

  return dUsers;
};